export default {"src":"/_next/static/media/0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f.684ff353.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};